// extracted by mini-css-extract-plugin
export var active = "_1n-9";
export var backButton = "_1n-8";
export var clone = "_1n-e";
export var collapseBar = "_1n-k";
export var collapseMode = "_1n-m";
export var collapsed = "_1n-o";
export var dimmed = "_1n-i";
export var dragHandle = "_1n-c";
export var dropdownIcon = "_1n-g";
export var expanding = "_1n-n";
export var hidden = "_1n-x";
export var iconContainer = "_1n-q";
export var iconSwapper = "_1n-w";
export var navItem = "_1n-6";
export var navItemIcon = "_1n-f";
export var navProfile = "_1n-7";
export var notificationCountBadge = "_1n-j";
export var notificationDot = "_1n-r";
export var optionsContainer = "_1n-h";
export var primaryNav = "_1n-0";
export var primaryNavDivider = "_1n-v";
export var primaryNavResizeHandle = "_1n-2";
export var primaryNavResizing = "_1n-1";
export var primaryNavTabSection = "_1n-u";
export var primaryTab = "_1n-p";
export var primaryTabIconBox = "_1n-s";
export var secondaryNav = "_1n-3";
export var selected = "_1n-t";
export var settingsNav = "_1n-4";
export var settingsNavItems = "_1n-5";
export var show = "_1n-d";
export var sideNav = "_1n-l";
export var teamItem = "_1n-a";
export var userProfileItem = "_1n-b";